module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "navigator mb-4"
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("Agents Report")]), _vm._v(" "), _c('range-picker', {
    on: {
      "input": _vm.getReport
    },
    model: {
      value: (_vm.selectedFilters.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilters, "dateRange", $$v)
      },
      expression: "selectedFilters.dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "report-area pb-4"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end my-2"
  }, [(_vm.serviceResponse) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.serviceResponse.pageInfo.totalItemCount,
      "items-per-page": _vm.pagination.itemsPerPage,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.pageChanged
    },
    model: {
      value: (_vm.pagination),
      callback: function($$v) {
        _vm.pagination = $$v
      },
      expression: "pagination"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.serviceResponse) ? _c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.serviceResponse.result
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-baef757c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baef757c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/reportSales.vue
// module id = 2963
// module chunks = 0